






























































import Vue from 'vue';
import { API } from '@/api';
import { mapActions } from 'vuex';

export default Vue.extend({
  data: () => ({
    openDialog: false,
    nuevoConcepto: {
      creationDateTime: '',
      creationUsername: '',
      ctaContable: '',
      descripcion: '',
      nombre: '',
      observaciones: '',
      adeudo: true,
      tipo: '',
      unidadMedida: '',
      impuesto: {},
    },
    loading: false,
    tipoConcepto: [
      'INGRESO',
      'EGRESO',
    ],
    tipoImpuesto: [],
    unidadesMed: [],
  }),
  mounted() {
    this.loadData();
  },
  methods: {
    ...mapActions(['getImpuesto']),
    modeloConcepto() {
      return {
        creationDateTime: '',
        creationUsername: '',
        ctaContable: '',
        descripcion: '',
        nombre: '',
        observaciones: '',
        adeudo: true,
        tipo: '',
        impuesto: {},
        unidadMedida: '',
      };
    },
    async loadData() {
      this.loading = true;
      try {
        const admin = this.$store.getters.getAdmin;
        const condo = this.$store.getters.getCondo;
        const result = await this.$store.dispatch('getImpuesto', {admin, condo});
        this.tipoImpuesto = result;
        console.debug('Impuestos: %o', this.tipoImpuesto);
      } catch (e) {
        console.error(e);
        this.$toast.error(e);
      }
      try {
        const admin = this.$store.getters.getAdmin;
        const condo = this.$store.getters.getCondo;
        const result = await this.$store.dispatch('getUnidadMed', {admin, condo});
        this.unidadesMed = result;
        console.debug('Impuestos: %o', this.unidadesMed);
        for (const unidMed of this.unidadesMed) {
          const label = unidMed.nombre + ' - (' + unidMed.descripcion + ')';
          unidMed.label = label;
        }
      } catch (e) {
        console.error(e);
        this.$toast.error(e);
      }
      this.loading = false;
    },
    async AgregarConcepto() {
      const isConceptoValid = this.validateConcepto(this.nuevoConcepto);
      if (isConceptoValid) {
        try {
          this.loading = true;
          const admin = this.$store.getters.getAdmin;
          const condo = this.$store.getters.getCondo;
          this.nuevoConcepto.adeudo = !this.nuevoConcepto.adeudo;
          this.nuevoConcepto.creationDateTime = this.$moment().format();
          this.nuevoConcepto.creationUsername = this.$store.getters.getUsername;
          const concepto = this.nuevoConcepto;
          const datos = {admin, condo, concepto};
          console.log('datos: %o', datos);
          const result = await this.$store.dispatch('addConcepto', {datos} );
          console.debug('Respuesta addPropietCondo: %o', result);
          this.$toast.success('Concepto agregado');
        } catch (e) {
          console.error(e);
          this.$toast.error(e.response.data.message);
        }
        this.loading = false;
        this.openDialog = false;
        this.$emit('reload', {});
      }
      return;
    },
    validateConcepto(concepto) {
      if (typeof(concepto.nombre) !== 'string' || concepto.nombre.length === 0) {
        this.$toast.error('Introduzca un nombre de concepto');
        return false;
      }
      /*if (typeof(concepto.ctaContable) !== 'string' || concepto.ctaContable.length === 0) {
        this.$toast.error('Introduzca una cuenta contable');
        return false;
      }*/
      if (typeof(concepto.unidadMedida) !== 'string' || concepto.unidadMedida.length === 0) {
        this.$toast.error('Seleccione una unidad de medida');
        return false;
      }
      if (typeof(concepto.tipo) !== 'string' || concepto.tipo.length === 0) {
        this.$toast.error('Seleccione un tipo');
        return false;
      }
      if (Object.keys(concepto.impuesto).length === 0) {
        this.$toast.error('Seleccione un impuesto');
        return false;
      }
      return true;
    },
  },
  watch: {
    openDialog() {
      if (!this.openDialog) {
        this.tipo = '';
        this.nuevoConcepto = this.modeloConcepto();
      }
    },
  },
});
